import { rotateForSession } from './boostRotation';

const DEFAULT_TARGET = 5;
const DEFAULT_BOOST_SHARE = 0.6;

export function pickSimilarListings(profile, allListings, options = {}) {
  if (!profile || !allListings?.length) return [];

  const target     = options.target     ?? DEFAULT_TARGET;
  const boostShare = options.boostShare ?? DEFAULT_BOOST_SHARE;
  const excludeIds = new Set(options.excludeIds || []);

  const now = new Date();
  const isActiveBoost = l =>
    l.is_boosted && l.boost_expires_at && new Date(l.boost_expires_at) > now;
  const byQuality = arr => [...arr].sort((a, b) => (b.qualityScore || 0) - (a.qualityScore || 0));

  const pick = (pool) => {
    const boostedPool  = rotateForSession(byQuality(pool.filter(isActiveBoost)));
    const organicPool  = byQuality(pool.filter(l => !isActiveBoost(l)));
    const boostSlots   = Math.ceil(target * boostShare);
    const takenBoosted = boostedPool.slice(0, boostSlots);
    const takenOrganic = organicPool.slice(0, Math.max(target - boostSlots, target - takenBoosted.length));
    return [...takenBoosted, ...takenOrganic].slice(0, target);
  };

  const base = allListings.filter(l => !excludeIds.has(l.id));

  // Tier 1: strict — same city + type + price ±30% + beds ±1
  const minPrice1 = profile.price * 0.7;
  const maxPrice1 = profile.price * 1.3;
  const minBeds   = (profile.bedrooms || 0) - 1;
  const maxBeds   = (profile.bedrooms || 0) + 1;
  const tier1 = base.filter(l =>
    l.city === profile.city &&
    l.type === profile.type &&
    l.price >= minPrice1 && l.price <= maxPrice1 &&
    (l.bedrooms || 0) >= minBeds && (l.bedrooms || 0) <= maxBeds
  );
  if (tier1.length >= 4) return pick(tier1);

  // Tier 2: same type + price ±50% (drop city/beds)
  const minPrice2 = profile.price * 0.5;
  const maxPrice2 = profile.price * 1.5;
  const tier2 = base.filter(l =>
    l.type === profile.type &&
    l.price >= minPrice2 && l.price <= maxPrice2
  );
  if (tier2.length >= 4) return pick(tier2);

  // Tier 3: same type, any price
  const tier3 = base.filter(l => l.type === profile.type);
  if (tier3.length >= 2) return pick(tier3);

  // Tier 4: anything by quality
  return pick(base);
}
